import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { MemberCategory }   from "Utils/API";



// The initial State
const initialState = {
    loading   : false,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    sort      : {
        orderBy  : "categoryCode",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "MEMBER_CATEGORY_LOADING" });
    },

    /**
     * Fetches the Member Category List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await MemberCategory.getAll(params);
        data.sort  = params;
        dispatch({ type : "MEMBER_CATEGORY_LIST", data });
    },

    /**
     * Fetches a single Member Category
     * @param {Function} dispatch
     * @param {Number}   categoryCode
     * @returns {Promise}
     */
    async fetchElem(dispatch, categoryCode) {
        const data = await MemberCategory.getOne({ categoryCode });
        dispatch({ type : "MEMBER_CATEGORY_ELEM", data });
    },

    /**
     * Edits/Creates a Member Category
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return MemberCategory.edit(data);
    },

    /**
     * Deletes a Member Category
     * @param {Function} dispatch
     * @param {Number}   categoryCode
     * @returns {Promise}
     */
    deleteElem(dispatch, categoryCode) {
        return MemberCategory.delete({ categoryCode });
    },
};



/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "MEMBER_CATEGORY_LIST", "MEMBER_CATEGORY_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "MEMBER_CATEGORY_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "MEMBER_CATEGORY_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : action.data.list,
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "MEMBER_CATEGORY_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : action.data.elem,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
